<template>
	<div class="advice-warp" v-loading="loading">
		<vuedraggable v-model="adviceList" handle=".advice_mover">
			<transition-group>
				<div
					class="item"
					v-for="(item, index) in adviceList"
					:key="item.vId"
					@mouseover="item.show = true"
					@mouseleave="item.show = false">
					<span class="iconfont icon-tuozhuai advice_mover"></span>
					<el-input type="text" :ref="`adviceInput_${item.vId}`" v-model.trim="item.content"></el-input>
					<div class="btn-warp" v-if="item.show">
						<el-button @click="handelTop(item.vId)">置顶</el-button>
						<el-button @click="handelUp(item.vId)"><i class="el-icon-top"></i></el-button>
						<el-button @click="handelDown(item.vId)"><i class="el-icon-bottom"></i></el-button>
						<el-button @click="handelRemove(item.vId)"><i class="el-icon-delete"></i></el-button>
					</div>
				</div>
			</transition-group>
		</vuedraggable>
		
		<div class="advice-bottom">
			<el-button type="text" @click="add"><i class="el-icon-plus"></i>新增</el-button>
			<div>
				<el-button @click="cancel">取消</el-button>
				<el-button @click="save" type="primary">保存</el-button>
			</div>
		</div>
	</div>
</template>
  
<script>
import vuedraggable from 'vuedraggable';
import { adviceList, adviceAdd } from "@/api/advice"; // 医嘱请求
export default {
	// 定义引入的组件
	components: {
		vuedraggable
	},
	props: {
		doctorInfo: Object
	},
	data() {
		return {
			adviceList: [],//医嘱列表
			addFalg: false,//是否新增
			loading: false,//内容
		}
	},
	//变量监听
	watch: {},
	// 页面初始化
	created() {
		this.getAdviceList()
	},
	// 页面DOM加载完成
	mounted() {},
	//离开页面时执行
	destroyed() {},
	// 页面方法
	methods: {
		generateUUID () {
			return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				const r = Math.random() * 16 | 0
				const v = c === 'x' ? r : (r & 0x3 | 0x8)
				return v.toString(16)
			})
		},
		/**
		 * 获取医嘱列表
		 */
		getAdviceList() {
			this.loading = true
			adviceList({ deptId: this.$session.get('deptId'), doctorId: this.doctorInfo.doctorId }).then(res => {
				let { code, rows } = res
				if (code == 200) {
					rows.map(v => {
						v['vId'] = this.generateUUID()
						v['show'] = false
					})
					this.adviceList = rows
					this.loading = false
				} else {
					this.loading = false
				}
			})
		},
		/**
		 * 新增医嘱
		 */
		add() {
			const vId = this.generateUUID()
			this.adviceList.push({
				vId: vId,
				doctorId: this.doctorInfo.doctorId,
				content: '',
				show: false
			})
			this.$nextTick(()=>{
				const adviceLastInput = this.$refs[`adviceInput_${vId}`][0]
				adviceLastInput.focus()
			})
		},
		/**
		 * 删除
		 */
		handelRemove(vId) {
			const index = this.adviceList.findIndex(v => v.vId == vId)
			if (index > -1) {
				this.adviceList.splice(index, 1)
			}
		},
		/**
		 * 置顶
		 */
		handelTop(vId) {
			let list = JSON.parse(JSON.stringify(this.adviceList))
			const index = list.findIndex(v => v.vId == vId)
			if (index > -1) {
				const [advice] = list.splice(index, 1)
				list.unshift(advice)
			}
			this.adviceList = list
		},
		/**
		 * 上移
		 */
		handelUp(vId) {
			let list = JSON.parse(JSON.stringify(this.adviceList))
			const index = list.findIndex(v => v.vId == vId)
			if (index > 0) {
				const [advice] = list.splice(index, 1)
				list.splice(index - 1, 0, advice)
			}
			this.adviceList = list
		},
		/** 
		 * 下移
		*/
		handelDown(vId) {
			let list = JSON.parse(JSON.stringify(this.adviceList))
			const index = list.findIndex(v => v.vId == vId)
			if (index > -1 && index < list.length - 1) {
				const [advice] = list.splice(index, 1)
				list.splice(index + 1, 0, advice)
			}
			this.adviceList = list
		},
		/**
		 * 取消
		 */
		cancel() {
			this.$emit('cancel')
		},
		/**
		 * 保存
		 */
		save() {
			try {
				this.adviceList.forEach(v => {
					if (['', null, undefined].includes(v.content)) {
						this.$refs[`adviceInput_${v.vId}`][0].focus()
						throw new Error('医嘱内容不能为空！')
					}
				})
				adviceAdd(this.adviceList).then(res => {
					if (res.code == 200) {
						this.$message.success('保存成功！');
						this.$emit('cancel')
					}
				})
			} catch (error) {
				this.$message.error(error.message)
			}
		}
	}
}
</script>
<style lang="less" scoped>
	.advice-warp {
    padding: 0 18px;
    padding-bottom: 20px;
    .item {
      display: flex;
      height: 44px;
      align-items: center;
      border-bottom: 1px solid #EBF2FF;

      /deep/.el-input__inner {
        border: 1px solid transparent;
      }

      /deep/.el-input__inner:focus {
        border-color: #409EFF;
      }

      /deep/.el-form-item.is-error .el-input__inner {
        border-color: #F56C6C;
      }

      .btn-warp {
        width: 290px;
        margin-left: 10px;

        .el-button {
          margin: 0;
        }
      }

      .item-content {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

  	.advice-bottom {
    	margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 20px;
    }
	}

	.advice_mover {
		font-size: 16px;
		color: #9AA0A8;
		cursor: pointer;
	}
</style>